export const WORKSPACE_ACTIVITY_CONTENT_ID = 'workspace-activity-content';
export const WORKSPACE_UPLOADS_ACTIVITY_CONTENT_ID = 'workspace-uploads-activity-content';
export const WORKSPACE_UPLOADS_TRAY_ID = 'workspace-uploads-tray';
export const WORKSPACE_IMPORTS_TRAY_ID = 'workspace-imports-tray';
